import { processGeojson } from 'kepler.gl/processors'
import { addDataToMap, layerConfigChange, layerVisConfigChange, layerVisualChannelConfigChange, addFilter, setFilter, interactionConfigChange, removeDataset } from 'kepler.gl/actions'
import { ZONE_AREAS } from '../../App.config'
import * as ActionTypes from './actionTypes'

// Dispatch Zone Areas To Map
export function loadZoneAreas(zoneAreas) {
  return (dispatch, getState) => {
    // Remove Previous Dataset
    dispatch( removeDataset(ZONE_AREAS.DATA_ID) )

    if(zoneAreas) {
      // Build `zone-areas` dataset
      const datasetInfo = { id: ZONE_AREAS.DATA_ID, label: ZONE_AREAS.DATA_LABEL }
      const data = processGeojson(zoneAreas)
      const dataset = { info: datasetInfo, data }

      // Options & Configs
      const options = { readOnly: true, centerMap: true }

      // Add Data to Map
      dispatch( addDataToMap({ datasets: [ dataset ], options }) )

      // Apply Configs
      const { map } = getState().keplerGl

      if(map) {
        // Layer Configs
        const { layers } = map.visState
        layers.forEach(l => {
          if(l.type === 'geojson' && l.config.dataId === datasetInfo.id) {
            // Apply Styles
            dispatch( layerVisConfigChange(l, {
              opacity: 0.01,
              strokeOpacity: 0.8,
              strokeColor: ZONE_AREAS.STROKE_COLOR,
              thickness: 1
            }) )

            // Color Range
            const colorRange = {
              category: 'Barikoi',
              colors: ZONE_AREAS.COLOR_PALETTE,
              name: 'Zones',
              type: 'quantile'
            }

            dispatch( layerVisConfigChange(l, { colorRange }) )

            // Set Color Field by to distinguish Zone Areas
            const _zoneAreasDataset = map.visState.datasets[ l.config.dataId ]
            const typeField = _zoneAreasDataset.fields.find(el => el.name === ZONE_AREAS.COLOR_KEY)

            // Dispatch Color Field By
            dispatch( layerVisualChannelConfigChange(l, { colorField: typeField }, 'color') )

            // Add Filter
            dispatch( addFilter(l.config.dataId) )

            // Tooltip Configs
            const fieldsToShow = ZONE_AREAS.TOOLTIP_FIELDS
            const { tooltip } = map.visState.interactionConfig
            tooltip.config.fieldsToShow[ l.config.dataId ] = fieldsToShow
            dispatch( interactionConfigChange(tooltip) )
          }
        })
      }
    }
  }
}

// Filter Zone Areas
export function filterZoneAreas(selectedZones) {
  return (dispatch, getState) => {
    let zoneNumbers = []

    // If selectedZones is empty
    if(!selectedZones || selectedZones.length === 0) {
      zoneNumbers = [ '' ]

    } else if(selectedZones.includes('All')) {
        // If `All` is selected
      zoneNumbers = []

    } else {
      // If Valid Zones Selected
      zoneNumbers = selectedZones
    }

    // Set Filter
    const { map } = getState().keplerGl
    if(map) {
      // Get Filter Index
      const { filters } = map.visState

      const filterIndex = filters.findIndex(f => f.dataId[0] === ZONE_AREAS.DATA_ID)

      if(filterIndex >= 0) {
        dispatch( setFilter(filterIndex, 'name', ZONE_AREAS.FILTER_KEY) )
        dispatch( setFilter(filterIndex, 'value', zoneNumbers) )
      }
    }
  }
}

// Set Zone Areas Layer Visibility
export function setZoneAreasLayerVisibility(isVisible) {
  return (dispatch, getState) => {
    const { map } = getState().keplerGl
    if(map) {
      const { layers } = map.visState
      layers.forEach(l => {
        if(l.type === 'geojson' && l.config.dataId === ZONE_AREAS.DATA_ID) {
          dispatch( layerConfigChange(l, { isVisible }) )
        }
      })
    }
  }
}

// Set Selected Zones
export function setSelectedZones(selectedZones) {
  return dispatch => {
    dispatch({ type: ActionTypes.SET_SELECTED_ZONES, payload: selectedZones })
  }
}